import React, { ReactNode, KeyboardEvent, useEffect, useRef } from "react";
import classnames from "classnames";

import "./WizardProfileTab.scss";

interface WizardProfileTabProps {
  id: string;
  isActive: boolean;
  onKeyPress: (e: KeyboardEvent) => void;
  onClick: (id: string) => void;
  children: ReactNode;
}

export const WizardProfileTab = ({
  id,
  children,
  isActive,
  onKeyPress,
  onClick,
}: WizardProfileTabProps) => {
  const tabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive) {
      tabRef.current.focus();
    }
  }, [isActive]);

  return (
    <div
      ref={tabRef}
      className={classnames(
        "wizard-profile-tab",
        isActive && "wizard-profile-tab--active"
      )}
      role="tab"
      data-id={id}
      id={`profileTab-${id}`}
      aria-selected={isActive}
      aria-controls={`profilePanel-${id}`}
      onClick={() => !isActive && onClick(id)}
      onKeyDown={onKeyPress}
      tabIndex={isActive ? 0 : -1}
    >
      {children}
    </div>
  );
};
